<template>
    <svg height="96" viewBox="0 0 96 96" width="96" xmlns="http://www.w3.org/2000/svg">
        <!-- @vue-ignore -->
        <g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-width="2">
            <circle cx="48" cy="48" r="39" />
            <path
                d="m48 25c2.5658229 0 4.8887396 1.0400052 6.5702005 2.7214662 1.681461 1.6814609 2.7214662 4.0043776 2.7214662 6.5702005s-1.0400052 4.8887395-2.7214662 6.5702005c-1.6814609 1.6814609-4.0043776 2.7214661-6.5702005 2.7214661s-4.8887396-1.0400052-6.5702005-2.7214661c-1.681461-1.681461-2.7214662-4.0043776-2.7214662-6.5702005s1.0400052-4.8887396 2.7214662-6.5702005c1.6814609-1.681461 4.0043776-2.7214662 6.5702005-2.7214662z"
            />
            <path
                d="m31.4390753 66.25v-7.1964286c0-4.1026867 3.3258847-7.4285714 7.4285714-7.4285714h18.1845238c4.1026867 0 7.4285715 3.3258847 7.4285715 7.4285714v7.1964286"
            />
        </g>
    </svg>
</template>
